import { computed, inject } from "vue";
import type {
  ICProdProvider,
  ICProdProviderMethods
} from "@/models/providers/contractProduct";

/**
 * Composable to inject contract product provider data and methods.
 * Replaces the cProdInjectorMixin for Composition API components.
 */
export function useCProdInjector() {
  const cProdDataProvider = inject<() => ICProdProvider>(
    "contractProductProvider"
  );
  const cProdMethodsProvider = inject<ICProdProviderMethods>(
    "contractProductProviderMethods"
  );

  if (!cProdDataProvider || !cProdMethodsProvider) {
    throw new Error(
      "useCProdInjector must be used within a component that has a contractProductProvider ancestor"
    );
  }

  const cProdData = computed(() => cProdDataProvider());

  return {
    cProdData,
    cProdMethods: cProdMethodsProvider
  };
}
